import * as ethicsFormType from './ethicsFormTypes'
import useEthicsForm from './useEthicsForm'
import MyTextfield from '../../../../control/textfield/textfield'
import Autocomplete from '../../../../control/autocomplete/autocomplete'
import { validateEN, validateChulaEmail, validateEmail } from '../../../../utilities/validate'
import { Button, Grid, IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import React from 'react'
import Radio from '../../../../control/radio/radio'
import Checkbox from '../../../../control/checkbox/checkbox'
import { useForm } from 'react-final-form'
import useTranslate from '../../../../i18n/useTranslate'
import MyAccordion from '../../../../control/accordion/accordion'
import { Fragment } from 'react'
import Select from '../../../../control/select/select'
import Tooltip from '../../../../control/tooltip/tooltip'
import { Add, AddCircleOutline, DeleteOutline, InfoOutlined } from '@material-ui/icons'
import UploadFile from '../uploadDoc/uploadfileEdit/uploadFileEdit'
import { FieldArray } from 'react-final-form-arrays'

//View
const EthicsFormView = (props: ethicsFormType.EthicsFormView) => {
    const {
        headerLabel,
        hideAccordion = false,
        faculty,
        researcherType,
        disabled = false,
        isDisableRIB = false,
        titleNameList,
        academicPositionList,
        isCertificatePaperList,
        researcherTypeSelected,
        isPhase,
        educationLevelLut,
        irbLut,
        isPhaseLut,
        isToolsLut,
        isDisablePhase = false,
        isDisableNumPhase = false,
        textRemaining,
        isShowNeedEditForm = false,
        isNeedEditForm,
        isDisableNeedEditForm = false,
        isShowAcademicPosition,
        onChangeResearcherType,
        onChangeAcademicPosition,
        onChangeTitleName,
        onChangeFaculty,
        onChangeIsPhase,
        onChangeIrb,
        onChangeHomePhone,
        onChangeMobilePhone,
        onChangeCertificatePaper,
        onChangTextField,
        onChangeNeedEditForm,
        addResearcher,
    } = props
    const classes = useStyles({})
    const translate = useTranslate()

    const form = useForm()
    const { values } = form.getState()
    const { academicPosition, titleName } = values
    const isPhaseFormValue = values.isPhase
    const mainResearcherType = values?.coResearcher?.[0]?.researcherType?.value
    const isMainResearcherStudent =
        mainResearcherType === ethicsFormType.ResearcherType.student
    const isShowEducationLevel =
        researcherTypeSelected === ethicsFormType.ResearcherType.student ||
        values?.researcherType?.value === ethicsFormType.ResearcherType.student
    const isAdvisorRequired = values?.IRB?.value !== '2' && isMainResearcherStudent

    const renderElement = (canEditFaculty = false) => (
        <Grid container item justify="flex-start" spacing={2}>
            {isShowNeedEditForm && (
                <Grid item xs={12} md={12} lg={12}>
                    <Radio
                        name="isNeedEditForm"
                        options={isPhaseLut}
                        labelGroup={translate.get('LABEL.NEED_EDIT_FORM')}
                        tooltipLabel={translate.get('LABEL.NEED_EDIT_FORM_INFO')}
                        onChangeValue={onChangeNeedEditForm}
                        requiredHalfWidth={true}
                        disabled={disabled || isDisableNeedEditForm}
                        required
                    />
                </Grid>
            )}
            <Grid item xs={12} md={12} lg={12}>
                <Typography>{translate.get('LABEL.PROJECT_INFO')}​</Typography>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                <Typography className={classes.fontDetail}>{translate.get('LABEL.LABEL_04')}​</Typography>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                <Radio
                    name="isPhase"
                    options={isPhaseLut}
                    labelGroup={translate.get('LABEL.LABEL_03')}
                    tooltipLabel={translate.get('LABEL.LABEL_03_1')}
                    onChangeValue={onChangeIsPhase}
                    requiredHalfWidth={true}
                    disabled={isDisablePhase || !isNeedEditForm}
                    required
                />
            </Grid>
            {(isPhase || isPhaseFormValue === '2') && (
                <Fragment>
                    <Grid item xs={12} md={12} lg={12}>
                        <Radio
                            name="isTools"
                            options={isToolsLut}
                            labelGroup={translate.get('LABEL.LABEL_05')}
                            requiredHalfWidth={true}
                            disabled={isDisableNumPhase || !isNeedEditForm}
                            required
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                        <MyTextfield
                            name="numPhase"
                            materialInputProps={{
                                disabled: isDisableNumPhase || !isNeedEditForm,
                                label: translate.get('LABEL.PHASE'),
                                placeholder: translate.get('LABEL.PHASE_PLACEHOLDER'),
                                size: 'small',
                            }}
                            required
                        />
                    </Grid>
                </Fragment>
            )}
            ​
            <Grid item xs={12} md={6} lg={6}>
                <Autocomplete
                    name="faculty"
                    materialInputProps={{
                        label: translate.get('LABEL.FACULTY_OFFICE_COLLEGE'),
                        placeholder: translate.get('LABEL.PLEASE_SELECT'),
                        disabled: disabled || !isNeedEditForm || !canEditFaculty,
                    }}
                    onChangeValue={onChangeFaculty}
                    options={faculty}
                    required
                    zIndex={1}
                />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Autocomplete
                    name="IRB"
                    materialInputProps={{
                        label: translate.get('LABEL.INSTITUTE_GROUP'),
                        placeholder: translate.get('LABEL.PLEASE_SELECT'),
                        disabled: isDisableRIB || !isNeedEditForm,
                    }}
                    onChangeValue={onChangeIrb}
                    options={irbLut}
                    required
                    zIndex={1}
                />
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                <MyTextfield
                    name="projectNameTH"
                    materialInputProps={{
                        disabled: disabled || !isNeedEditForm,
                        label: `${translate.get('LABEL.PROJECT_NAME')}​ (${translate.get(
                            'LABEL.THAI',
                        )}​) ${translate.get('LABEL.PLEASE_FILL_DATA')}`,
                        placeholder: `${translate.get('LABEL.PROJECT_NAME')}​ (${translate.get(
                            'LABEL.THAI',
                        )}​) ${translate.get('LABEL.CAN_BE_FILL_ENG')} ${translate.get('LABEL.PLEASE_FILL_DATA')}`,
                        size: 'small',
                        rows: 5,
                        multiline: true,
                    }}
                    maxLength={500}
                    handleValueChange={(val) => {
                        onChangTextField(val, 'TH')
                    }}
                    required
                />
            </Grid>
            {!disabled && (
                <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'end', marginTop: '-22px' }}>
                    <small>
                        {translate.get('LABEL.NUMBER_OF_CHARACTERS')} : {textRemaining?.TH}
                    </small>
                </Grid>
            )}
            <Grid item xs={12} md={12} lg={12}>
                <MyTextfield
                    name="projectNameEN"
                    materialInputProps={{
                        disabled: disabled || !isNeedEditForm,
                        label: `${translate.get('LABEL.PROJECT_NAME')}​ (${translate.get('LABEL.ENG')}​)`,
                        placeholder: `${translate.get('LABEL.PROJECT_NAME')}​ (${translate.get('LABEL.ENG')}​)`,
                        size: 'small',
                        rows: 5,
                        multiline: true,
                    }}
                    validates={[validateEN(translate.get('MESSAGE.M001'))]}
                    maxLength={500}
                    handleValueChange={(val) => {
                        onChangTextField(val, 'EN')
                    }}
                    required
                />
            </Grid>
            {!disabled && (
                <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'end', marginTop: '-22px' }}>
                    <small>
                        {translate.get('LABEL.NUMBER_OF_CHARACTERS')} : {textRemaining?.EN}
                    </small>
                </Grid>
            )}
            <Grid item xs={12} md={12} lg={12}>
                <MyTextfield
                    name="researchProjectSummaryTH"
                    materialInputProps={{
                        disabled: disabled || !isNeedEditForm,
                        label: `${translate.get('LABEL.RESEARCH_PROJECT_SUMMARY')}​ ${translate.get('LABEL.PLEASE_FILL_DATA')}`,
                        placeholder: `${translate.get('LABEL.RESEARCH_PROJECT_SUMMARY')}​ `,
                        size: 'small',
                        rows: 5,
                        multiline: true,
                    }}
                    maxLength={500}
                    handleValueChange={(val) => {
                        onChangTextField(val, 'TH')
                    }}
                    required
                />
            </Grid>
            {!disabled && (
                <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'end', marginTop: '-22px' }}>
                    <small>
                        {translate.get('LABEL.NUMBER_OF_CHARACTERS')} : {textRemaining?.TH}
                    </small>
                </Grid>
            )}
            {/* <Grid item xs={12} md={12} lg={12}>
                <MyTextfield
                    name="researchProjectSummaryEN"
                    materialInputProps={{
                        disabled: disabled || !isNeedEditForm,
                        label: `${translate.get('LABEL.RESEARCH_PROJECT_SUMMARY')}​ (${translate.get('LABEL.ENG')}​)`,
                        placeholder: `${translate.get('LABEL.RESEARCH_PROJECT_SUMMARY')}​ (${translate.get('LABEL.ENG')}​)`,
                        size: 'small',
                        rows: 5,
                        multiline: true,
                    }}
                    validates={[validateEN(translate.get('MESSAGE.M030'))]}
                    maxLength={500}
                    handleValueChange={(val) => {
                        onChangTextField(val, 'EN')
                    }}
                    required
                />
            </Grid>
            {!disabled && (
                <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'end', marginTop: '-22px' }}>
                    <small>
                        {translate.get('LABEL.NUMBER_OF_CHARACTERS')} : {textRemaining?.EN}
                    </small>
                </Grid>
            )} */}
            <Grid item xs={12} md={6}>
                <MyTextfield
                    name="projectAdvisor"
                    materialInputProps={{
                        disabled: disabled || !isNeedEditForm,
                        label: translate.get('LABEL.ADVISOR_NAME'),
                        placeholder: translate.get('LABEL.ADVISOR_NAME'),
                    }}
                    maxLength={250}
                    required={isAdvisorRequired}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <MyTextfield
                    name="projectAdvisorEmail"
                    materialInputProps={{
                        disabled: disabled || !isNeedEditForm,
                        label: translate.get('LABEL.ADVISOR_EMAIL'),
                        placeholder: translate.get('LABEL.ADVISOR_EMAIL'),
                    }}
                    validates={[validateChulaEmail(translate.get('MESSAGE.M031'))]}
                    maxLength={250}
                    required={isAdvisorRequired}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <MyTextfield
                    name="projectAdvisorEmailReserve"
                    materialInputProps={{
                        disabled: disabled || !isNeedEditForm,
                        label: translate.get('LABEL.ADVISOR_EMAIL_RESERVE'),
                        placeholder: translate.get('LABEL.ADVISOR_EMAIL_RESERVE'),
                    }}
                    validates={[validateEmail(translate.get('MESSAGE.M031'))]}
                    maxLength={250}
                />
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                {/* <UploadFile dataSource={null} topicID={1} name="researchProjectSummary" label="Upload File" /> */}
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                <Typography className={classes.line}></Typography>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                <Typography>{translate.get('LABEL.CERTIFICATE_REQ_INFO')}​</Typography>
            </Grid>
            <Grid container item xs={12} md={12} lg={12}>
                <Grid item xs={12} md={12} lg={12}>
                    <Typography variant={'subtitle2'}>
                        {/* //className={​classes.label}​> */}​{translate.get('LABEL.CERTIFICATE_LANGUAGE')}​
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4} lg={2} xl={1}>
                    <Checkbox
                        name="langTH"
                        label={translate.get('LABEL.THAI')}
                        disabled={disabled || !isNeedEditForm}
                    />
                </Grid>
                <Grid item xs={12} md={8} lg={10} xl={11}>
                    <Checkbox name="langEN" label={translate.get('LABEL.ENG')} disabled={disabled || !isNeedEditForm} />
                </Grid>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                <Radio
                    name="isCertificatePaperList"
                    options={isCertificatePaperList}
                    labelGroup={translate.get('LABEL.GET_PAPER_CERTIFICATE')}
                    onChangeValue={onChangeCertificatePaper}
                    requiredHalfWidth={true}
                    disabled={disabled || !isNeedEditForm}
                    required
                />
            </Grid>
        </Grid>
    )
    return (
        <React.Fragment>
            {hideAccordion ? (
                renderElement(false)
            ) : (
                <MyAccordion title={headerLabel ?? translate.get('LABEL.LABEL_01')}>{renderElement(true)}</MyAccordion>
            )}
        </React.Fragment>
    )
}
//Controller
const EthicsForm = (props: ethicsFormType.EthicsFormType) => {
    // const {​ disabled }​ = props
    const createFormModel = useEthicsForm(props)
    return <EthicsFormView {...createFormModel} {...props} />
}
export default EthicsForm
const useStyles = makeStyles((theme) => ({
    fontDetail: {
        fontSize: '14px',
        color: '#bfbfbf',
    },
    line: {
        borderTop: '1px solid #c7c7c7',
        marginBottom: '2%',
    },
}))
